<template>
<div class="col-12 tabs-menu">
  <router-link :to="{ name: 'aquazor-users'}">
    <div class="menu-tab" v-bind:class="{active: isUsers}">Пользователи</div>
  </router-link>
  <router-link :to="{ name: 'statistic'}">
    <div class="menu-tab" v-bind:class="{active: isStatistic}">Статистика</div>
  </router-link>
  <router-link :to="{ name: 'aquazor-settings'}">
    <div class="menu-tab" v-bind:class="{active: isSettings}">Настройки</div>
  </router-link>
</div>
</template>

<script>
import {
  store
} from '@/store'

export default {
  name: 'admin-menu-block',
  props: ['page'],
  computed: {
    isUsers: function () {
      return this.page == 'aquazor-users'
    },
    isStatistic: function () {
      return this.page == 'statistic'
    },
    isSettings: function () {
      return this.page == 'aquazor-settings'
    }
  },
  methods: {

  }
}
</script>



// WEBPACK FOOTER //
// src/components/elements/admin_menu.vue